import { ReactElement } from "react";
import { Route } from "react-router-dom";
import { useFamaFlags } from "../api/FamaFlags";

type MisconductListViewByFlagProps = {
  v2025: ReactElement;
  v2026: ReactElement;
};

export function MisconductListViewByFlag({
  v2025,
  v2026,
}: MisconductListViewByFlagProps) {
  const { v3UiMisconductListsV2026 } = useFamaFlags();
  return v3UiMisconductListsV2026 === true ? v2026 : v2025;
}

export type MisconductListRouteConfig = {
  path: string;
  v2025: ReactElement;
  v2026: ReactElement;
};

export function misconductListRouteElements({
  path,
  v2025,
  v2026,
}: MisconductListRouteConfig) {
  return [
    <Route
      key={path}
      path={path}
      element={<MisconductListViewByFlag v2025={v2025} v2026={v2026} />}
    />,
    <Route key={`${path}/v2025`} path={`${path}/v2025`} element={v2025} />,
    <Route key={`${path}/v2026`} path={`${path}/v2026`} element={v2026} />,
  ];
}
